import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { SIZES_WITH_RESPONSIVE_OPTION } from './types';

export default function Spacer({ size, className }) {
    const classes = {};

    if (Array.isArray(size)) {
        size.forEach((item, index) => {
            classes[`bp-${index}-${item}`] = true;
            classes[`bp-${index}`] = true;
        });
    }
    else {
        classes[`${size}`] = true;
    }

    return (
        <div
            data-component="Spacer"
            className={cx('sarsa-spacer', classes, className)} />
    )
}

Spacer.propTypes = {
    /** OneOf(['none', 'gutter', 'xxs', 'xs', 'sm', 'md', 'lg', 'xl', 'xxl'])
     * or array of sizes (one per mobile, tablet and desktop breakpoints)
     */
    size: SIZES_WITH_RESPONSIVE_OPTION,

    /** Additional class added to the outer container */
    className: PropTypes.string
};
